export default {"src":"/_next/static/media/Errori.c9c0794a.svg","height":43,"width":43};